/* ============================================================
   The Plain Word: The Gospels landing page JS
   No frameworks, no build step.
   ============================================================ */

/* ---- Checkout ----
   Every CTA on the page reads from these constants.
   $27 ebook link (prod_UtBU4NOWTmNjm9), $39 paperback pre-order link (prod_Uv549UervQi5gZ). */
const CHECKOUT_URL = '/cart/49276894019835:1?skip_shop_pay=true';
const PAPERBACK_URL = '/cart/49276893954299:1?skip_shop_pay=true';

function klaviyoTrack(event, props) {
  if (window.klaviyo) {
    window.klaviyo.push(['track', event, props]);
  }
}

/* Visitors arriving from a paperback ad (utm_content=pb-*, or a campaign named
   paperback/pre-order) were promised a printed book. For the rest of their
   session, every generic CTA points at the paperback pre-order instead of the
   $27 ebook, so the page delivers what the ad sold. */
let paperbackVisitor = false;
try {
  const params = new URLSearchParams(location.search);
  if (/^pb/i.test(params.get('utm_content') || '') || /paperback|pre-?order|pre-?launch/i.test(params.get('utm_campaign') || '')) {
    sessionStorage.setItem('tpw_pb', '1');
  }
  paperbackVisitor = sessionStorage.getItem('tpw_pb') === '1';
} catch (e) { /* storage blocked: fall back to ebook CTAs */ }

function trackCheckout(product, price) {
  if (typeof fbq === 'function') {
    fbq('track', 'InitiateCheckout', {content_name: product, value: price, currency: 'USD'});
  }
  klaviyoTrack('Started Checkout', {Product: product, Price: price});
}

document.querySelectorAll('[data-checkout]').forEach(function (link) {
  if (paperbackVisitor) {
    link.setAttribute('href', PAPERBACK_URL);
    const priceSpan = link.querySelector('.nav-cta-price');
    if (priceSpan) {
      link.innerHTML = 'Pre-order the paperback<span class="nav-cta-price"> &middot; $39</span>';
    } else {
      link.textContent = 'Pre-order the paperback · $39';
    }
    link.addEventListener('click', function () {
      trackCheckout('The Plain Word: Paperback Pre-Order', 39.00);
    });
  } else {
    link.setAttribute('href', CHECKOUT_URL);
    link.addEventListener('click', function () {
      trackCheckout('The Plain Word: The Gospels', 27.00);
    });
  }
});

document.querySelectorAll('[data-ebook-checkout]').forEach(function (link) {
  link.setAttribute('href', CHECKOUT_URL);
  link.addEventListener('click', function () {
    trackCheckout('The Plain Word: The Gospels', 27.00);
  });
});

document.querySelectorAll('[data-paperback-checkout]').forEach(function (link) {
  link.setAttribute('href', PAPERBACK_URL);
  link.addEventListener('click', function () {
    trackCheckout('The Plain Word: Paperback Pre-Order', 39.00);
  });
});

document.querySelectorAll('[data-bundle-checkout]').forEach(function (link) {
  link.addEventListener('click', function () {
    trackCheckout('The Plain Word: Complete Bundle', 44.00);
  });
});

/* ---- Site nav: mobile menu toggle ---- */
(function () {
  const nav = document.getElementById('site-nav');
  const toggle = document.getElementById('nav-toggle');
  if (!nav || !toggle) return;

  toggle.addEventListener('click', function () {
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });

  // Close the menu when a link inside it is tapped (anchor jumps stay smooth).
  var closeBtn=document.getElementById('nav-close');if(closeBtn){closeBtn.addEventListener('click',function(){nav.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');});}
  nav.querySelectorAll('.mnav-links a').forEach(function (link) {
    link.addEventListener('click', function () {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  });
})();

/* ---- Email capture: "Get the first chapter free" ----
   Posts to /api/subscribe: instant chapter email via Resend + Klaviyo list add.
   localStorage keeps a local copy of the lead as a belt-and-suspenders backup. */
(function () {
  // Container is optional: the homepage wraps the form in .capture-card, the
  // advertorial page in .adv-cta. Requiring .capture-card here silently killed
  // the advertorial form for weeks (fixed Aug 3).
  const form = document.getElementById('capture-form');
  const card = form ? (form.closest('.capture-card') || form.parentElement) : null;
  if (!form) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    const input = document.getElementById('capture-email');
    const email = (input.value || '').trim();

    // Minimal sanity check; the browser's type="email" does the rest.
    if (!email || email.indexOf('@') === -1) {
      input.focus();
      return;
    }

    try {
      const leads = JSON.parse(localStorage.getItem('tpw_chapter_leads') || '[]');
      leads.push({ email: email, at: new Date().toISOString() });
      localStorage.setItem('tpw_chapter_leads', JSON.stringify(leads));
    } catch (err) {
      /* storage unavailable: fail quietly */
    }

    const hp = document.getElementById('capture-hp');
    const evid = 'lead-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    fetch('https://api.theplainword.com/api/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, website: hp ? hp.value : '', event_id: evid }),
    }).catch(function () { /* lead kept in localStorage; success state stays */ });

    // Identify the visitor to Klaviyo so later buy-button clicks fire
    // Started Checkout against their profile (powers the abandonment flow).
    if (window.klaviyo) {
      window.klaviyo.push(['identify', { email: email }]);
    }

    if (typeof fbq === 'function') {
      fbq('track', 'Lead', { content_name: 'Free chapter (Luke 15)', value: 0, currency: 'USD' }, { eventID: evid });
    }

    form.classList.add('is-done');
    if (card) card.classList.add('is-done');
    // Belt-and-suspenders: some pages style the done-state via .is-done rules,
    // others (advertorial) have none — toggle visibility directly too.
    form.style.display = 'none';
    const success = document.getElementById('capture-success');
    if (success) { success.hidden = false; success.style.display = 'block'; }
  });
})();

/* ---- Sticky mobile CTA bar ----
   Appears once the hero CTA scrolls out of view, hides over the final CTA
   so the page never shows two buy buttons at once. */
(function () {
  const bar = document.getElementById('sticky-bar');
  const hero = document.querySelector('.hero');
  const finalCta = document.querySelector('.final-cta');
  if (!bar || !hero || !('IntersectionObserver' in window)) return;

  let pastHero = false;
  let overFinal = false;

  function update() {
    const show = pastHero && !overFinal;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  new IntersectionObserver(function (entries) {
    pastHero = !entries[0].isIntersecting;
    update();
  }, { threshold: 0.1 }).observe(hero);

  if (finalCta) {
    new IntersectionObserver(function (entries) {
      overFinal = entries[0].isIntersecting;
      update();
    }, { threshold: 0.15 }).observe(finalCta);
  }
})();

/* ---- Reveal on scroll (progressive enhancement) ---- */
(function () {
  const items = document.querySelectorAll('.reveal');
  if (!items.length) return;

  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px' });

  items.forEach(function (el) { observer.observe(el); });
})();

/* ---- Free chapter slide-in: once per session, 40% scroll, skip known leads ---- */
(function () {
  const el = document.getElementById('chapter-slidein');
  if (!el) return;
  const knownLead = (localStorage.getItem('tpw_chapter_leads') || '[]') !== '[]';
  if (knownLead || sessionStorage.getItem('tpw_slidein_shown')) return;

  let shown = false;
  function maybeShow() {
    if (shown) return;
    const depth = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
    if (depth > 0.4) {
      shown = true;
      sessionStorage.setItem('tpw_slidein_shown', '1');
      el.classList.add('is-visible');
      el.setAttribute('aria-hidden', 'false');
      window.removeEventListener('scroll', maybeShow);
    }
  }
  window.addEventListener('scroll', maybeShow, { passive: true });

  document.getElementById('slidein-close').addEventListener('click', function () {
    el.classList.remove('is-visible');
    el.setAttribute('aria-hidden', 'true');
  });

  document.getElementById('slidein-form').addEventListener('submit', function (e) {
    e.preventDefault();
    const email = (document.getElementById('slidein-email').value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return;
    el.classList.add('is-done');
    try {
      const leads = JSON.parse(localStorage.getItem('tpw_chapter_leads') || '[]');
      leads.push({ email: email, at: new Date().toISOString(), src: 'slidein' });
      localStorage.setItem('tpw_chapter_leads', JSON.stringify(leads));
    } catch (err) {}
    if (window.klaviyo) { window.klaviyo.push(['identify', { email: email }]); }
    fetch('https://api.theplainword.com/api/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    }).catch(function () {});
    setTimeout(function () {
      el.classList.remove('is-visible');
      el.setAttribute('aria-hidden', 'true');
    }, 3500);
  });
})();

// Verse expander (rage-click fix, Jul 29): "Keep reading" on the Luke 15 compare card.
document.querySelectorAll('[data-verse-toggle]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
    if (!open) {
      btn.querySelector('.verse-more-caret').textContent = '▴';
      // Nudge the newly revealed text into view on small screens.
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else {
      btn.querySelector('.verse-more-caret').textContent = '▾';
    }
  });
});

// Live momentum line under the hero CTA — real trailing-7-day order count from Stripe.
(function () {
  var el = document.getElementById('order-momentum');
  if (!el) return;
  fetch('https://api.theplainword.com/api/order-count?window=all')
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (!d || !d.show || !d.count) return;
      var n = Math.floor(d.count / 5) * 5;
      document.getElementById('order-momentum-text').textContent = n + '+ readers have already ordered';
      el.hidden = false;
      var sc = document.getElementById('star-count'); if (sc) sc.textContent = ' · ' + n + '+ orders';
    })
    .catch(function () {});
})();

// Real-pages lightbox: every verse card + the explicit button opens actual page
// spreads. Converts the standing dead-click cluster into the see-inside answer.
(function () {
  var lb = document.getElementById('pages-lightbox');
  if (!lb) return;
  function open() { lb.hidden = false; document.body.style.overflow = 'hidden'; }
  function close() { lb.hidden = true; document.body.style.overflow = ''; }
  document.querySelectorAll('[data-open-pages]').forEach(function (b) { b.addEventListener('click', open); });
  document.querySelectorAll('.verse-card').forEach(function (card) {
    card.addEventListener('click', function (e) {
      // The Luke card's own expander keeps priority; links/buttons inside cards keep working.
      if (e.target.closest('a, button')) return;
      open();
    });
  });
  lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target.closest('[data-close-pages]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
})();


/* ---- inline scripts from index.html ---- */

document.body.classList.remove('loaded');
window.addEventListener('load',()=>{document.getElementById('loader').classList.add('done');document.body.classList.add('loaded');});
setTimeout(()=>{document.getElementById('loader').classList.add('done');document.body.classList.add('loaded');},1800);

// progress + header
const prog=document.getElementById('prog'),hdr=document.getElementById('hdr'),sticky=document.getElementById('sticky-bar');
const hero=document.getElementById('order');
window.addEventListener('scroll',()=>{
  const h=document.documentElement;
  if(prog)prog.style.transform=`scaleX(${h.scrollTop/(h.scrollHeight-h.clientHeight)})`;
  if(hdr)hdr.classList.toggle('scrolled',h.scrollTop>40);
  if(sticky){var _c=document.getElementById('cta-main');var past=_c?_c.getBoundingClientRect().bottom<0:(hero&&h.scrollTop>hero.offsetTop+hero.offsetHeight);sticky.classList.toggle('show',past&&h.scrollTop<h.scrollHeight-h.clientHeight-600);}
},{passive:true});

// cursor
const dot=document.getElementById('cursor-dot'),ring=document.getElementById('cursor-ring');
let mx=0,my=0,rx=0,ry=0;
window.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;dot.style.left=mx+'px';dot.style.top=my+'px';});
(function loop(){rx+=(mx-rx)*.16;ry+=(my-ry)*.16;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(loop)})();
document.querySelectorAll('a,button').forEach(el=>{
  el.addEventListener('mouseenter',()=>ring.classList.add('hovering'));
  el.addEventListener('mouseleave',()=>ring.classList.remove('hovering'));
});

// reveal
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in-view');io.unobserve(e.target)}}),{threshold:.14});
document.querySelectorAll('.reveal,.stagger').forEach(el=>io.observe(el));
// Fallback: IntersectionObserver never fires in hidden/background tabs — reveal
// anything already inside the viewport on scroll, and everything if the tab is hidden.
function revealFallback(){
  document.querySelectorAll('.reveal:not(.in-view),.stagger:not(.in-view)').forEach(el=>{
    if(document.visibilityState==='hidden'||el.getBoundingClientRect().top<innerHeight*.92)el.classList.add('in-view');
  });
}
window.addEventListener('scroll',revealFallback,{passive:true});
document.addEventListener('visibilitychange',revealFallback);
setTimeout(revealFallback,1200);setInterval(revealFallback,2000);

// gallery: thumb 1 shows the 3D paperback; photo thumbs swap in the image
const galMain=document.getElementById('gal-main');
const gal3d=document.getElementById('gal-3d');
var galUserChose=false;
document.querySelectorAll('#thumbs button').forEach(b=>b.addEventListener('click',(ev)=>{
  if(ev&&ev.isTrusted)galUserChose=true;
  document.querySelectorAll('#thumbs button').forEach(x=>x.classList.remove('active'));
  b.classList.add('active');
  if(!galMain)return;
  galMain.hidden=false;
  galMain.style.opacity=0;
  setTimeout(()=>{galMain.src=b.dataset.src;galMain.style.opacity=1;},160);
}));
// Default view: 3D book on desktop, photo on mobile. The viewport width isn't
// settled at parse time (in-app browsers open small then expand), so this
// re-applies on load, on resize, and on the media query flipping — but never
// after the reader has picked a thumb themselves.
var galMQ=window.matchMedia('(max-width:700px)');
function galleryDefault(){ if(gal3d){gal3d.style.display='none';} if(galMain){galMain.hidden=false;} return;
  if(galUserChose)return;
  var btns=document.querySelectorAll('#thumbs button');
  var want=galMQ.matches?1:0;
  if(btns[want]&&!btns[want].classList.contains('active'))btns[want].click();
}
window.addEventListener('load',galleryDefault);
window.addEventListener('resize',galleryDefault);
if(galMQ.addEventListener)galMQ.addEventListener('change',galleryDefault);
setTimeout(galleryDefault,600);setTimeout(galleryDefault,1500);

// format selector: swaps price, label, checkout permalink (cart is REPLACED, never doubled) and sticky bar
const cta=document.getElementById('cta-main'),pl=document.getElementById('price-copy'),pn=document.getElementById('price-now');
const priceCopy={
  '39':'Paperback with the $27 ebook included, a <s>$66</s> value. Free shipping in the US &amp; Canada.',
  '63':'Two paperbacks, one to keep and one to give, shipped together. The $27 ebook is included, a <s>$105</s> value. Free shipping.',
  '44':'Large Type: the same four Gospels set bigger and airier. Includes the <s>$27</s> ebook tonight. Free shipping in the US &amp; Canada.',
  '27':'PDF + EPUB, delivered to your inbox within minutes. Read it on your phone, tablet or Kindle tonight.'
};
document.querySelectorAll('.fmt').forEach(f=>f.addEventListener('click',()=>{
  document.querySelectorAll('.fmt').forEach(x=>x.classList.remove('active'));
  f.classList.add('active');
  var _v=document.getElementById('cta-variant'); if(_v&&f.dataset.variant){_v.value=f.dataset.variant;}
  if(cta){cta.querySelector('span').textContent=f.dataset.label;if(f.dataset.variant){cta.href='/cart/'+f.dataset.variant+':1?skip_shop_pay=true';}}
  var sb=document.getElementById('sb-cta');if(sb&&f.dataset.variant){sb.href='/cart/'+f.dataset.variant+':1?skip_shop_pay=true';}
  var sp=document.getElementById('sb-price');if(sp){sp.textContent='$'+f.dataset.price;}
  var nb=document.getElementById('nav-buy');if(nb&&f.dataset.variant){nb.href='/cart/'+f.dataset.variant+':1?skip_shop_pay=true';nb.querySelector('span').textContent='Get the book · $'+f.dataset.price;}
  if(pn){pn.textContent='$'+f.dataset.price;}
  var gb=document.getElementById('gal-badge');if(gb){gb.querySelector('strong').textContent=(f.dataset.price==='44')?'Large Type edition':(f.dataset.price==='27'?'Ebook only':(f.dataset.price==='63'?'Two copies':'Reader edition'));}
  if(f.dataset.price==='44'&&!galUserChose){var eb=document.querySelector('#thumbs button:nth-child(3)');if(eb){eb.click();galUserChose=false;}}
  if(pl&&priceCopy[f.dataset.price]){pl.innerHTML=priceCopy[f.dataset.price];}
}));

// v28 two-copy bump: a checkbox under the chips, shown only while the Reader edition is selected.
// Checked = the Two Copies permalink ($63). Unchecked, or any other chip tapped = exactly the v27 chip behaviour
// (unchecking re-taps the Reader chip, so every v27 handler restores the $39 state itself).
(function(){
  var box=document.getElementById('bump-two'),row=document.getElementById('fmt-bump');
  if(!box||!row||!cta)return;
  var READER='49276893954299';
  function applyTwo(){
    var link=box.dataset.link,price=box.dataset.price;
    row.classList.add('on');
    cta.href=link;cta.querySelector('span').textContent=box.dataset.label;
    var sb=document.getElementById('sb-cta');if(sb){sb.href=link;}
    var sp=document.getElementById('sb-price');if(sp){sp.textContent='$'+price;}
    var nb=document.getElementById('nav-buy');if(nb){nb.href=link;nb.querySelector('span').textContent='Get the book · $'+price;}
    if(pn){pn.textContent='$'+price;}
    if(pl&&priceCopy[price]){pl.innerHTML=priceCopy[price];}
    var q=document.getElementById('cta-qty');if(q){q.name='updates['+box.dataset.variant+']';}
    var gb=document.getElementById('gal-badge');if(gb){gb.querySelector('strong').textContent='Two copies';}
  }
  function sync(){
    var a=document.querySelector('.fmt.active');var isReader=!!a&&a.dataset.variant===READER;
    row.hidden=!isReader;
    if(!isReader){box.checked=false;row.classList.remove('on');return;}
    if(box.checked){applyTwo();}
  }
  box.addEventListener('change',function(){
    if(typeof clarity==='function'){clarity('event',box.checked?'bump_two_on':'bump_two_off');}
    if(box.checked){applyTwo();return;}
    row.classList.remove('on');
    var r=document.querySelector('.fmt[data-variant="'+READER+'"]');if(r){r.click();}
  });
  document.querySelectorAll('.fmt').forEach(function(f){f.addEventListener('click',function(){
    box.checked=false;row.classList.remove('on');row.hidden=f.dataset.variant!==READER;
  });});
  sync();window.addEventListener('pageshow',sync);
})();

// verse tabs
const verses=[
 {v:'Luke 15:20 · The Lost Son comes home',
  o:'“And he arose, and came to his father. But when he was yet a great way off, his father saw him, and had compassion, and ran, and fell on his neck, and kissed him.”',
  n:'“So he got up and headed home. But while he was still a long way down the road, his father saw him. And his father\'s heart broke with love, and he ran. He threw his arms around his son and kissed him.”'},
 {v:'Matthew 5:3–4 · The Sermon on the Mount',
  o:'“Blessed are the poor in spirit: for theirs is the kingdom of heaven. Blessed are they that mourn: for they shall be comforted.”',
  n:'“God blesses those who know they need him. The Kingdom of Heaven belongs to them. God blesses those who are grieving. They will be comforted.”'},
 {v:'Matthew 5:14–15 · The light of the world',
  o:'“Ye are the light of the world. A city that is set on an hill cannot be hid. Neither do men light a candle, and put it under a bushel, but on a candlestick; and it giveth light unto all that are in the house.”',
  n:'“You are the light of the world. A city built on a hill can\'t be hidden. And nobody lights a lamp and then hides it under a basket. You put it up on a stand. Then it shines for everyone in the house.”'}
];
document.querySelectorAll('#ba-tabs button').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('#ba-tabs button').forEach(x=>x.classList.remove('active'));
  b.classList.add('active');
  const d=verses[+b.dataset.i];
  document.getElementById('ba-old').textContent=d.o;
  document.getElementById('ba-new').textContent=d.n;
  document.getElementById('ba-verse').textContent=d.v;
}));

// faq
document.querySelectorAll('.faq-q').forEach(q=>q.addEventListener('click',()=>{
  const item=q.parentElement,a=item.querySelector('.faq-a'),open=item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i=>{i.classList.remove('open');i.querySelector('.faq-a').style.maxHeight=0});
  if(!open){item.classList.add('open');a.style.maxHeight=a.scrollHeight+'px'}
}));


// 3D flipbook: sheets rotate on their left edge; z-order managed per flip.
(function(){
  var book=document.getElementById('flipbook');if(!book)return;
  var sheets=[].slice.call(book.querySelectorAll('.fb-sheet'));
  var total=sheets.length, at=0; // number of flipped sheets
  var prev=document.getElementById('fb-prev'),next=document.getElementById('fb-next'),state=document.getElementById('fb-state');
  var labels=['Front cover','Pages 308–309','Pages 310–311','The last page · pre-order'];
  function zs(){sheets.forEach(function(sh,i){sh.style.zIndex = sh.classList.contains('flipped') ? (i+1) : (total-i);});}
  function ui(){
    book.classList.toggle('closed', at===0);
    prev.disabled = at===0; next.disabled = at===total;
    state.textContent = labels[at] || '';
  }
  function go(dir){
    var idx = dir>0 ? at : at-1;
    var sh = sheets[idx]; if(!sh) return;
    sh.style.zIndex = 99;
    sh.classList.toggle('flipped', dir>0);
    at += dir;
    setTimeout(zs, 1000);
    ui();
  }
  next.addEventListener('click',function(){ if(at<total) go(1); });
  prev.addEventListener('click',function(){ if(at>0) go(-1); });
  book.addEventListener('click',function(e){
    var r=book.getBoundingClientRect();
    if(e.clientX > r.left + r.width/2){ if(at<total) go(1); } else { if(at>0) go(-1); }
  });
  zs();ui();
})();

// Live momentum counter: real Stripe data via /api/order-count; hides below 5.
(function(){
  var el=document.getElementById('momentum-count');var pill=el&&el.closest('.momentum');
  if(!el)return;
  fetch('https://api.theplainword.com/api/order-count?window=all').then(function(r){return r.json()}).then(function(d){
    if(d&&d.show&&d.count){el.textContent=(Math.floor(d.count/5)*5)+'+ readers have already ordered';if(pill){pill.style.display='';}}
    else if(pill){pill.style.display='none';}
  }).catch(function(){ if(pill){pill.style.display='none';} });
})();

// Free-chapter capture: same contract as v1 — POST /api/subscribe {email}.
(function(){
  var form=document.getElementById('capture-form');if(!form)return;
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var input=document.getElementById('capture-email');
    var email=(input.value||'').trim();
    if(!email||email.indexOf('@')===-1){input.focus();return;}
    try{var leads=JSON.parse(localStorage.getItem('tpw_chapter_leads')||'[]');leads.push({email:email,at:new Date().toISOString()});localStorage.setItem('tpw_chapter_leads',JSON.stringify(leads));}catch(err){}
    var hp=document.getElementById('capture-hp');
    var evid='lead-'+Date.now()+'-'+Math.random().toString(36).slice(2,10);
    fetch('https://api.theplainword.com/api/subscribe',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:email,website:hp?hp.value:'',event_id:evid})}).catch(function(){});
    if(window.klaviyo){window.klaviyo.push(['identify',{email:email}]);}
    if(typeof fbq==='function'){fbq('track','Lead',{content_name:'Free chapter (Luke 15)',value:0,currency:'USD'},{eventID:evid});}
    form.hidden=true;document.getElementById('capture-success').hidden=false;
  });
})();

// Buy-click tracking parity with v1: InitiateCheckout + Klaviyo Started Checkout.
(function(){
  document.querySelectorAll('a[href*="buy.stripe.com"]').forEach(function(link){
    link.addEventListener('click',function(){
      var two=link.href.indexOf('AE07')!==-1;
      var paper=link.href.indexOf('AE05')!==-1||two;
      var product=two?'The Plain Word: Paperback x2 Pre-Order':(paper?'The Plain Word: Paperback Pre-Order':'The Plain Word: Digital');
      var price=two?63.00:(paper?39.00:27.00);
      if(typeof fbq==='function'){fbq('track','InitiateCheckout',{content_name:product,value:price,currency:'USD'});}
      if(window.klaviyo){window.klaviyo.push(['track','Started Checkout',{ProductName:product,Price:price}]);}
    });
  });
})();


// Add-to-cart alternative under the hero CTA: same form, land in the cart instead of checkout.
(function(){
  var cc=document.getElementById('cta-cart'),f=document.getElementById('cta-form');
  if(!cc||!f)return;
  cc.addEventListener('click',function(){var r=f.querySelector('[name=return_to]');if(r){r.value='/cart';}f.submit();});
})();

